import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { Textarea } from '../ui/Textarea';
import { MascotPanel } from '../ui/MascotPanel';
export function Step9Type() {
  const {
    data,
    updateData
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-508">
      <MascotPanel message="Laten we het technisch maken. Wat voor type website bouwen we en welke functionaliteiten zijn onmisbaar?" detailedInfo="Dit formulier is geen indicatie! Hier maakt u echte keuzes voor uw project. De opties die u hier kiest bepalen welke pagina's u in de volgende stap kunt selecteren." data-id="element-509" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-510">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-511">Type Website</h2>

        <div data-id="element-512">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-513">
            Wat voor type website heeft u nodig?
          </label>
          <RadioGroup columns={1} value={data.websiteType} onChange={val => updateData({
          websiteType: val
        })} options={[{
          value: 'website',
          label: 'Website',
          description: "Meerdere pagina's en opties (geen verkoop van producten)"
        }, {
          value: 'webshop',
          label: 'Webshop',
          description: 'Verkoop van spullen met winkelwagen en afrekenen'
        }, {
          value: 'onepager',
          label: 'Onepager',
          description: 'Homepagina en verder niets (evt. 1 extra pagina of blogs)'
        }]} data-id="element-514" />
        </div>

        <AnimatePresence data-id="element-515">
          {data.websiteType === 'webshop' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 pt-6 border-t border-gray-100 overflow-hidden" data-id="element-516">
              <h3 className="font-semibold text-gray-900" data-id="element-517">Webshop Details</h3>
              <Textarea label="Hoe wilt u dat de producten erin worden gezet?" placeholder="Bijv. handmatig, via een import, koppeling met boekhouding..." value={data.productManagement} onChange={e => updateData({
            productManagement: e.target.value
          })} data-id="element-518" />
            </motion.div>}

          {(data.websiteType === 'website' || data.websiteType === 'webshop') && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 pt-6 border-t border-gray-100 overflow-hidden" data-id="element-519">
              <h3 className="font-semibold text-gray-900" data-id="element-520">
                Portaal & Gebruikers
              </h3>

              <div data-id="element-521">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-522">
                  Moet er een klantenportaal komen?
                </label>
                <RadioGroup columns={2} value={data.needsPortal} onChange={val => updateData({
              needsPortal: val
            })} options={[{
              value: 'yes',
              label: 'Ja, klanten moeten kunnen inloggen'
            }, {
              value: 'no',
              label: 'Nee, dat is niet nodig'
            }]} data-id="element-523" />
              </div>

              {data.needsPortal === 'yes' && <div className="space-y-6 mt-4" data-id="element-524">
                  <Textarea label="Wat moet het portaal onthouden/tonen aan de klant?" placeholder="Bijv. bestelgeschiedenis, facturen, afspraken..." value={data.portalDetails} onChange={e => updateData({
              portalDetails: e.target.value
            })} data-id="element-525" />
                  <Textarea label="Zijn er meerdere mensen met verschillende rollen?" placeholder="Bijv. beheerder, medewerker, klant..." value={data.userRoles} onChange={e => updateData({
              userRoles: e.target.value
            })} data-id="element-526" />
                </div>}
            </motion.div>}
        </AnimatePresence>

        <div className="bg-blue-50 rounded-xl p-6 border border-blue-100" data-id="element-527">
          <p className="text-sm text-blue-800" data-id="element-528">
            <strong data-id="element-529">Goed om te weten:</strong> Wij bouwen onze websites altijd
            in WordPress, gecombineerd met Elementor (en WooCommerce voor
            webshops). Dit zorgt voor een flexibel en gebruiksvriendelijk
            systeem.
          </p>
        </div>
      </div>
    </motion.div>;
}